import { useEffect, useState } from 'react';
import { isInstantBooking } from '../../annuaire/bookingState';
import {
  fetchAvailability,
  fetchPublicShop,
} from '../../annuaire/tunnel/v2Api';
import { MAX_SPAN_DAYS } from '../../annuaire/tunnel/bookingRequest';
import { jourDans } from '../../annuaire/tunnel/creneaux';

/**
 * Le mode et les horaires libres d'un atelier Fixer Lite, pour la carte de
 * rendez-vous et la barre basse mobile de la fiche.
 *
 * Le mode vient de la fiche (`fixer_lite.instant_booking`, servi au rendu
 * serveur) ; la fiche publique `/v2` le confirme dans le navigateur, comme le
 * tunnel. Les horaires se chargent dans le navigateur, sur 21 jours : la
 * fiche servie au crawler n'en a pas. `actif` à faux : aucun appel.
 */
export default function useRdvAtelier(shop, actif = true) {
  const [compte, setCompte] = useState(null);
  const [dispo, setDispo] = useState({ etat: 'charge', slots: [] });
  const id = shop && shop.id;

  useEffect(() => {
    if (!actif || !id) return undefined;
    let annule = false;
    // D'une fiche à l'autre (ateliers similaires), le composant reste monté :
    // on n'affiche pas les horaires de l'atelier précédent.
    setCompte(null);
    setDispo({ etat: 'charge', slots: [] });
    fetchPublicShop(id)
      .then((c) => !annule && setCompte(c || {}))
      // En panne, le mode de la fiche servie fait foi (le tunnel dira l'erreur).
      .catch(() => !annule && setCompte({}));
    fetchAvailability(id, jourDans(0), jourDans(MAX_SPAN_DAYS), null)
      .then(
        (d) => !annule && setDispo({ etat: 'ok', slots: (d && d.slots) || [] }),
      )
      .catch(() => !annule && setDispo({ etat: 'erreur', slots: [] }));
    return () => {
      annule = true;
    };
  }, [actif, id]);

  const instant =
    compte && typeof compte.instant_booking === 'boolean'
      ? compte.instant_booking
      : isInstantBooking(shop);

  const details = (shop && shop.details) || {};
  const tel =
    (compte && compte.contact_phone) ||
    (shop && shop.phone) ||
    details.telephone_google ||
    '';

  // Les horaires n'apparaissent qu'une fois le mode connu : un horaire cliqué
  // dans le mauvais mode ne voudrait rien dire pour le tunnel.
  const pret = compte !== null;

  return { instant, tel, dispo: pret ? dispo : { etat: 'charge', slots: [] } };
}
